import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "balance-section" }
const _hoisted_2 = { class: "balance-amount" }
const _hoisted_3 = { class: "balance-detail" }
const _hoisted_4 = { class: "button-group" }
const _hoisted_5 = { class: "settings-list" }
const _hoisted_6 = { class: "right-content" }
const _hoisted_7 = { class: "help-text" }

import CustomTitleBar from "@/components/CustomTitleBar/index.vue";
import { onMounted } from "vue";
import { getBalance } from "@/api/wallet";
import { ref } from "vue";
import { showToast } from "vant";
import router from "@/router";

interface BalanceData {
  balance: number;
  availableBalance: number;
  frozenBalance: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const balanceData = ref<BalanceData>({
  balance: 0,
  availableBalance: 0,
  frozenBalance: 0
});

onMounted(() => {
  getBalanceData()
})

const getBalanceData = () => {
  getBalance().then(res => {
    if (res.code === 200) {
      balanceData.value = res.data
    } else {
      showToast(res.msg)
    }
  })
}

const go = (path: string) => {
  router.push(path)
}

const handleRechargeClick = () => {
  router.push('/Recharge')
}

const handleWithDrawalClick = () => {
  router.push('/WithDrawal')
}

const handleLimitClick = () => {
  // 处理提高限额点击
  go('/AuthSfz')
}

const handleResetPasswordClick = () => {
  // 处理重置支付密码点击
  go('/ResetPayPwd')
}

const handleBankCardClick = () => {
  // 处理银行卡管理点击
  go('/BankCard')
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ArrowRight = _resolveComponent("ArrowRight")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomTitleBar, {
      title: "我的口袋",
      "right-text": "账单",
      "icon-color": "#fff",
      "title-color": "#fff",
      "right-text-color": "#fff",
      "background-color": 'transparent',
      fixed: true,
      "show-border": false,
      onRightClick: _cache[0] || (_cache[0] = ($event: any) => (go('/BillingRecord')))
    }),
    _createElementVNode("div", _hoisted_1, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "balance-title" }, "鲸油", -1)),
      _createElementVNode("div", _hoisted_2, _toDisplayString(balanceData.value.balance), 1),
      _createElementVNode("div", _hoisted_3, " 其中可用 " + _toDisplayString(balanceData.value.availableBalance) + " 鲸油，冻结中 " + _toDisplayString(balanceData.value.frozenBalance) + " 鲸油 ", 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          class: "action-btn",
          onClick: handleRechargeClick
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("充值")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          class: "action-btn",
          onClick: handleWithDrawalClick
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode("提现")
          ])),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "settings-title" }, "常见设置", -1)),
      _createElementVNode("div", {
        class: "settings-item",
        onClick: handleLimitClick
      }, [
        _cache[6] || (_cache[6] = _createElementVNode("span", null, "提高限额", -1)),
        _createElementVNode("div", _hoisted_6, [
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "hint-text" }, "上传身份信息", -1)),
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_ArrowRight)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", {
        class: "settings-item",
        onClick: handleResetPasswordClick
      }, [
        _cache[7] || (_cache[7] = _createElementVNode("span", null, "重置支付密码", -1)),
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_ArrowRight)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", {
        class: "settings-item",
        onClick: handleBankCardClick
      }, [
        _cache[8] || (_cache[8] = _createElementVNode("span", null, "银行卡管理", -1)),
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_ArrowRight)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[10] || (_cache[10] = _createTextVNode(" 如有疑问联系鲸宝：")),
      _createElementVNode("div", {
        class: "help-link",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleHelpClick && _ctx.handleHelpClick(...args)))
      }, "客服")
    ])
  ], 64))
}
}

})